/**
 * Tracks a page view for Google Analytics (gtag.js).
 * This function should be called after Barba.js has transitioned to a new page
 * to ensure that single-page application navigations are recorded.
 * @param {object} data - Barba's transition data object, typically from `afterEnter`.
 */
export function trackGoogleAnalyticsPageView(data) {
  if (typeof gtag === 'function') {
    // Construct the page path including search parameters if they exist.
    const pagePath = data.next.url.path + (data.next.url.search || '');
    // Get the full URL for the new page.
    const pageLocation = data.next.url.href;
    // document.title is updated by Barba.js by the time `afterEnter` runs (if sync:true).
    const pageTitle = document.title;

    gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: pageTitle,
      page_location: pageLocation
    });
    console.log(`Barba GA: Page view tracked - path: ${pagePath}, title: ${pageTitle}, location: ${pageLocation}`);
  } else {
    console.warn('Barba GA: gtag function not found. Analytics not tracked for this view. Ensure GA script is loaded.');
  }
}
